import styled, { css } from 'styled-components';

import { JSS_CTA_CLASS, Cta } from 'core/components/Cta/Cta.style';

import { Segment } from 'core/components/DynamicSubLayout/DynamicSubLayout.style';

export const CtaContainer = styled.div<{
	margin?: string;
	disableFullWidth: boolean;
}>`
	display: block;

	${({ margin }) =>
		margin &&
		css`
			margin: ${margin};
		`}

	.cta {
		margin: 0;
		justify-content: center;
	}

	${Segment} {
		display: flex;
		align-items: center;
	}

	${({ disableFullWidth }) =>
		!disableFullWidth &&
		css`
			.dynamicSubLayout.-stacked {
				${Cta},
				.${JSS_CTA_CLASS} {
					width: 100%;
				}
			}
		`}
`;
